import { AuditTimeline } from '../../../shared/features/history/components/AuditTimeline';
import { useHistory } from '../../../shared/features/history/hooks/use-history';

/** The customer's whole history: field edits, status changes and contact changes are all audited against `entityType: 'customer'`. */
export function CustomerHistoryTab({ customerId }: { customerId: string }) {
  const state = useHistory('customer', customerId, true);
  return <AuditTimeline state={state} />;
}
